var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"cont"},[_c('p',[_vm._v("技术支持：武汉易测云网络科技有限公司")]),_c('p',[_vm._v("热线：027-87581599")])])]),_c('div',{staticClass:"bot"},[_vm._v("Copyright.©2018 Etesting. All Rights Reserved.")])])
}]

export { render, staticRenderFns }